import revive_payload_client_Frd8gASYWa from "/builds/connection-ticketing/boats-spa/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_3Bi0E2Ktsf from "/builds/connection-ticketing/boats-spa/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_CrWB4n4PyO from "/builds/connection-ticketing/boats-spa/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import _0_siteConfig_l19uMh4P89 from "/builds/connection-ticketing/boats-spa/node_modules/nuxt-site-config/dist/runtime/nuxt/plugins/0.siteConfig.js";
import payload_client_T5aD6w6QZh from "/builds/connection-ticketing/boats-spa/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_JA9PnUIOcc from "/builds/connection-ticketing/boats-spa/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_yxgjJ9XxnV from "/builds/connection-ticketing/boats-spa/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_kCUITUWXUN from "/builds/connection-ticketing/boats-spa/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_BKbTeWPbAR from "/builds/connection-ticketing/boats-spa/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_KR1HBZs4kY from "/builds/connection-ticketing/boats-spa/web-app/.nuxt/components.plugin.mjs";
import prefetch_client_5ZRYOjuei0 from "/builds/connection-ticketing/boats-spa/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_CHalsvJBex from "/builds/connection-ticketing/boats-spa/node_modules/nuxt-jsonld/dist/runtime/plugin.js";
import switch_locale_path_ssr_7CGgCC9Jj0 from "/builds/connection-ticketing/boats-spa/node_modules/@nuxtjs/i18n/dist/runtime/plugins/switch-locale-path-ssr.js";
import i18n_DqO8wZLCYH from "/builds/connection-ticketing/boats-spa/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.js";
import _00_site_CR5DZM6WZW from "/builds/connection-ticketing/boats-spa/web-app/plugins/00.site.ts";
import _01_currency_44CEkVfyFU from "/builds/connection-ticketing/boats-spa/web-app/plugins/01.currency.ts";
import analitycs_manager_gLn08hyCRn from "/builds/connection-ticketing/boats-spa/web-app/plugins/analitycs-manager.ts";
import dayjs_pGiXRjcsJO from "/builds/connection-ticketing/boats-spa/web-app/plugins/dayjs.ts";
import ga_interceptor_0qns2yy6ow from "/builds/connection-ticketing/boats-spa/web-app/plugins/ga-interceptor.ts";
import klaviyo_signup_client_rbHUDrY00X from "/builds/connection-ticketing/boats-spa/web-app/plugins/klaviyo-signup.client.ts";
import sentry_client_shVUlIjFLk from "/builds/connection-ticketing/boats-spa/web-app/plugins/sentry.client.ts";
import session_keep_alive_client_NdhjvfFeKl from "/builds/connection-ticketing/boats-spa/web-app/plugins/session-keep-alive.client.ts";
import visit_beacon_client_wYJFIxo8kM from "/builds/connection-ticketing/boats-spa/web-app/plugins/visit-beacon.client.ts";
import vue_final_modal_pML93k5qcp from "/builds/connection-ticketing/boats-spa/web-app/plugins/vue-final-modal.ts";
import vue3_toastify_OGYNDsiW9E from "/builds/connection-ticketing/boats-spa/web-app/plugins/vue3-toastify.ts";
export default [
  revive_payload_client_Frd8gASYWa,
  unhead_3Bi0E2Ktsf,
  router_CrWB4n4PyO,
  _0_siteConfig_l19uMh4P89,
  payload_client_T5aD6w6QZh,
  navigation_repaint_client_JA9PnUIOcc,
  check_outdated_build_client_yxgjJ9XxnV,
  chunk_reload_client_kCUITUWXUN,
  plugin_vue3_BKbTeWPbAR,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5ZRYOjuei0,
  plugin_CHalsvJBex,
  switch_locale_path_ssr_7CGgCC9Jj0,
  i18n_DqO8wZLCYH,
  _00_site_CR5DZM6WZW,
  _01_currency_44CEkVfyFU,
  analitycs_manager_gLn08hyCRn,
  dayjs_pGiXRjcsJO,
  ga_interceptor_0qns2yy6ow,
  klaviyo_signup_client_rbHUDrY00X,
  sentry_client_shVUlIjFLk,
  session_keep_alive_client_NdhjvfFeKl,
  visit_beacon_client_wYJFIxo8kM,
  vue_final_modal_pML93k5qcp,
  vue3_toastify_OGYNDsiW9E
]